import auth from '@simmons/auth-store';

export default auth;
